import { render, staticRenderFns } from "./ProjectTile.vue?vue&type=template&id=256c5d0a&"
import script from "./ProjectTile.vue?vue&type=script&lang=js&"
export * from "./ProjectTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports